import { HttpHeaders, HttpClient } from '@angular/common/http';
import { ConfigService } from './config.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "./config.service";
export class ZoneService {
    constructor(http, configService) {
        this.http = http;
        this.configService = configService;
        this.jsonContent = {
            headers: new HttpHeaders({
                'Content-Type': 'application/json',
                'Authorization': sessionStorage.getItem('batoken'),
                'User': sessionStorage.getItem('userid')
            })
        };
    }
    getZonas() {
        const userid = sessionStorage.getItem('userid');
        const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('batoken'), User: userid });
        return this.http.get(`${this.configService.API_URL}/zonas/listazonas?user=${userid}`, { headers }).toPromise();
    }
    getAllZonas() {
        const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('batoken') });
        return this.http.get(`${this.configService.API_URL}/zonas`, { headers }).toPromise();
    }
    getZonasbyUserId(user) {
        const userid = sessionStorage.getItem('userid');
        const headers = new HttpHeaders({ Authorization: sessionStorage.getItem('batoken'), User: userid });
        return this.http.get(`${this.configService.API_URL}/zonas/listazonas?user=${user}`, { headers }).toPromise();
    }
    update(user, zonaId) {
        return this.http.put(`${this.configService.API_URL}/zonas/${zonaId}`, user, Object.assign({}, this.jsonContent, { responseType: 'text' })).toPromise();
    }
    create(user) {
        return this.http.post(`${this.configService.API_URL}/zonas`, user, Object.assign({}, this.jsonContent, { responseType: 'text' })).toPromise();
    }
    getZonasDisponibles() {
        return this.http.get(`${this.configService.API_URL}/zonas/find-zonas-disponibles`, Object.assign({}, this.jsonContent, { responseType: 'json' })).toPromise();
    }
    getZonaUsuario(userId) {
        return this.http.get(`${this.configService.API_URL}/zonas/find-zonas-usuario?userId=${userId}`, Object.assign({}, this.jsonContent, { responseType: 'json' })).toPromise();
    }
    deleteZona(zoneId) {
        return this.http.delete(`${this.configService.API_URL}/zonas/${zoneId}`, Object.assign({}, this.jsonContent, { responseType: 'json' })).toPromise();
    }
}
ZoneService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function ZoneService_Factory() { return new ZoneService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.ConfigService)); }, token: ZoneService, providedIn: "root" });
